import moment from 'moment';
import { Moment } from 'moment';

import { StatsContainerComponent } from './stats-container/stats-container.component';
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { User } from "../../common/models/user";
import { Directive } from "@angular/core";

@Directive()
export abstract class BaseStats {
    public organization: Organization = {} as Organization;
    public athlete: Athlete = {} as Athlete;
    public user: User = {} as User;

    public _dateFrom: Moment = moment(new Date());
    public _dateTo: Moment = moment(new Date());

    public options: Object = {};
    public loaded = false;

    public _parentContainer: StatsContainerComponent = {} as StatsContainerComponent;

    set dateFrom(dateFrom: Moment) {
        this._dateFrom = dateFrom;
    }

    get dateFrom(): Moment {
        return this._dateFrom;
    }

    set dateTo(dateTo: Moment) {
        this._dateTo = dateTo;
    }

    get dateTo(): Moment {
        return this._dateTo;
    }

    set parentContainer(parentContainer: StatsContainerComponent) {
        this._parentContainer = parentContainer;
    }

    public refreshData() {
        this.populateData();
    }

    public updateTitle() {
        this._parentContainer.pageTitle = this.getTitle();
    }

    protected abstract populateData() : void;

    protected abstract getTitle(): string;

    protected percent(value: number, total: number) {
        if (total === 0) {
            return 0;
        }

        return value * 100 / total;
    }
}

export default BaseStats;
